<template>
  <div class="second-sidebar">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'sidebar-menu'
  }
</script>
<style lang="scss">
  .second-sidebar {
    position: fixed;
    width: 280px;
    left: 80px;
    top: 0;
    height: 100vh;
    overflow-y: auto;
    background: $left-menu-gray;
    box-shadow: inset -30px 0px 141px -97px #7E7E7E;
    z-index: 100;
    padding: 20px;
  }
</style>
